import { User } from '../models/user';

export class AddBeekeeperUserIdSuccess {
    static readonly type = '[User] AddBeekeeperUserIdSuccess';

    constructor(public payload: User) {}
}
